import VotingChart from "../components/VotingChart";
import { useParams } from "react-router-dom";

function PastVotingPage() {
  let params = useParams();
  return (
      <VotingChart limit={30} votingId={params.votingId}/>
  );
}

export default PastVotingPage;
